import { render, staticRenderFns } from "./UpdateVehicleImage.vue?vue&type=template&id=70c18e3c&"
import script from "./UpdateVehicleImage.vue?vue&type=script&lang=js&"
export * from "./UpdateVehicleImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports